import { Injectable } from '@angular/core';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
import { ProxyService } from '@core/services/proxy.service';
import { PickupTypeMetadata, PickupType, ServiceArea } from '@core/redux/stores';

@Injectable()
export class PickupTimeService {

  constructor(private proxyService: ProxyService) { }
  getTime(locationID, query, isImmediate = true) {
    let getUrl = ApiRoutes.LOCATIONS + locationID + '/order-pickup-options?orderTotal=' + query;
    if (isImmediate) {
      getUrl += '&isImmediate=' + isImmediate;
    }
    return this.proxyService.httpGet(getUrl);
  }
getFallbackPickupType(pickupTypeMetadata: PickupTypeMetadata[], availablePickupTypes: number[], pickupmethod: PickupType):
   PickupTypeMetadata {
    const result = pickupTypeMetadata.find((p: PickupTypeMetadata) => p.pickupType ===  pickupmethod)
                    .fallbackPickupTypes.find(f => availablePickupTypes.includes(f));
    return result ? pickupTypeMetadata.find(p => p.pickupType === result) : null;
  }
  getDspConfig(locationID, localTime = null) {
    const url = ApiRoutes.LOCATIONS + locationID + '/dsp-config' + (localTime ? ('?localDateTimeUrlEncoded=' + localTime) : '') ;
    return this.proxyService.httpGet(url);
  }
}
